module.exports = __webpack_public_path__ + "static/img/501349062.57d12a0f.png";